export default "__VITE_ASSET__1dee06dd__"